import React from 'react';
import useTranslation from '../../../../hooks/translation/useTranslation';

function ScheduleListHeader() {
  const { trans } = useTranslation();
  const headerClassName = 'text-base font-bold m-0 flex-1 flex justify-center';
  return (
    <div className="hidden lg:flex w-full justify-between items-center gap-1">
      <h3 className={`${headerClassName} sticky left-0 bg-gray-light-gr h-full`}>
        {trans('train/n')}
      </h3>
      <h3 className={`${headerClassName} flex-[2]`}>{trans('ride')}</h3>
      <h3 className={headerClassName}>{trans('stop')}</h3>
      <h3 className={headerClassName}>{trans('exit')}</h3>
      <h3 className={headerClassName}>{trans('arrival')}</h3>
    </div>
  );
}

export default ScheduleListHeader;
